import { render, staticRenderFns } from "./CreateUserEvents.vue?vue&type=template&id=2e4d263f"
import script from "./CreateUserEvents.vue?vue&type=script&lang=js"
export * from "./CreateUserEvents.vue?vue&type=script&lang=js"
import style0 from "./CreateUserEvents.vue?vue&type=style&index=0&id=2e4d263f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports